import { ApiClientAxios, apiFactoryConfig, DocumentDownloadResponse } from "@repo/api";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

type FufiLifeDocumentsProps = {
    proposalNumber: string;
    options?: Partial<UseQueryOptions<DocumentDownloadResponse[]>>;
};

export const useFufiLifeDocuments = ({ proposalNumber, options }: FufiLifeDocumentsProps) => {
    const api = ApiClientAxios.DocumentsApiFactory(...apiFactoryConfig);

    return useQuery<DocumentDownloadResponse[]>({
        queryKey: ["getFufiLifeDocuments", proposalNumber],
        queryFn: async () => {
            const data = (await api.getLifeFufiDocumentsGet(proposalNumber)).data;
            return data.map((doc) => ({
                ...doc,
                dateCreated: new Date(doc.dateCreated),
            }));
        },
        ...options,
    });
};
